module.exports = __webpack_public_path__ + "img/ElevateCard.94ac5aff.png";